import styled from 'styled-components';

type EventProps = {
  color: string;
};

type HourProps = {
  color: string;
};

export const Container = styled.div`
  margin: 0;
  padding: 0;
  position: absolute;
  width: 100vw;
  background-color: ${({ theme }) => theme.colors.background_white};

  h1 {
    font-size: 18px;
    color: ${({ theme }) => theme.colors.secondary};
    font-weight: 500;
  }
`;

export const Content = styled.div`
  position: relative;
`;

export const WrapperButtonsSynchronizeSchedule = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  position: absolute;
  top: 2rem;
  right: 0;
  width: 97px;
  height: 166px;
  background-color: ${({ theme }) => theme.colors.background_white};
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 13px;
  z-index: 1;

  & > div {
    display: flex;
    flex-direction: column;
    align-items: center;

    p {
      color: ${({ theme }) => theme.colors.tertiary_500};
      font-weight: 400;
      font-size: 0.75rem;
    }
  }

  .icon-google-schedule {
    width: 2.5rem;
  }

  .icon-outlook {
    width: 2rem;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 1rem;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.secondary};

  img {
    width: 52px;
    height: 52px;
    align-self: flex-end;
    padding-right: 4rem;
    margin-bottom: -1.5rem;
  }

  div {
    margin-left: 2rem;
  }
`;

export const ChooseDate = styled.div`
  width: 10rem;
  color: ${({ theme }) => theme.colors.secondary};
  border-color: ${({ theme }) => theme.colors.secondary};
  margin-left: 3rem;
  margin-bottom: 0.8rem;

  .MuiInputBase-root {
    border-radius: 0.7rem;
    outline: none;
  }

  .MuiOutlinedInput-root:hover {
    fieldset {
      border-color: ${({ theme }) => theme.colors.primary};
    }
  }

  .MuiInputBase-input {
    padding: 0.3rem 0 0.3rem 0.4rem;
    display: disabled;
    border-radius: 10rem;
    caret-color: transparent;
    color: ${({ theme }) => theme.colors.secondary};
    font-family: 'Futura PT';
    font-weight: 350;
    font-size: 18px;
  }

  .MuiButtonBase-root {
    padding: 0;
    margin: 0;

    svg {
      color: ${({ theme }) => theme.colors.primary};
    }
  }

  .MuiOutlinedInput-notchedOutline {
    border-color: ${({ theme }) => theme.colors.primary};
  }

  .MuiPaper-elevation {
    background-color: red !important;
  }
`;

export const ContainerCalendar = styled.div`
  overflow: scroll;
  position: relative;
  max-height: 75vh;
  min-height: 69vh;
`;

export const Calendar = styled.table`
  position: relative;
  border-collapse: collapse;

  thead {
    th {
      position: sticky;
      top: 0;
      z-index: 1;
    }

    th:first-child {
      left: 0;
      z-index: 1;
    }

    .day-week {
      min-width: 160px;
      min-height: 62px;
      max-height: 62px;
      background-color: ${({ theme }) => theme.colors.primary};
      padding-left: 1rem;
      color: ${({ theme }) => theme.colors.background_white};
      text-align: start;
      z-index: 99;
      strong {
        font-weight: 900;
        font-size: 20px;
      }

      p {
        margin: 0;
        padding: 0;
        font-weight: 400;
        font-size: 0.9rem;
      }
    }
  }

  tbody {
    th {
      position: sticky;
      left: 0;
      z-index: 1;
    }
  }
`;

export const Hour = styled.th<HourProps>`
  min-width: 48px;
  height: 88px;
  font-size: 16px;
  background-color: ${({ color }) => color};
  color: ${({ theme }) => theme.colors.primary};
`;

export const WrapperEvents = styled.td<EventProps>`
  width: 10rem;
  height: 88px;
  background-color: ${({ color }) => color};
  position: relative;
`;
